import React, { useEffect } from 'react'
import Hero from '../components/aboutUs/Hero'
import MissionVision from '../components/aboutUs/MissionVision'
import OurStrengths from '../components/aboutUs/OurStrengths'
import UniqueSP from '../components/aboutUs/UniqueSP'
import Values from '../components/aboutUs/Values'

const AboutUs = () => {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  
  return (
    <div className='h-fit w-full' >

      <Hero />

      <MissionVision />
      
      <Values />

      {/* <OurStrengths /> */}

      <UniqueSP />


      
    </div>
  )
}

export default AboutUs
